import type { Tile } from "../types";

const getVergeScrews = (
  tile: Tile,
  getProductQuantity: (productCode: string) => number
): number => {
  if (!tile.vergeOption || !tile.vergeScrew) {
    return 0;
  }

  let totalCalculatedVergeTiles =
    getProductQuantity(tile.vergeOption.left.code) +
    getProductQuantity(tile.vergeOption.right.code);

  if (tile.vergeOption.halfLeft) {
    totalCalculatedVergeTiles += getProductQuantity(
      tile.vergeOption.halfLeft.code
    );
  }
  if (tile.vergeOption.halfRight) {
    totalCalculatedVergeTiles += getProductQuantity(
      tile.vergeOption.halfRight.code
    );
  }

  return totalCalculatedVergeTiles * 2;
};

export default getVergeScrews;
